import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { ApolloProvider } from './data/apollo'

import Appsignal from '@appsignal/javascript'
import { plugin as appSignalBreadcrumbsNetwork } from '@appsignal/plugin-breadcrumbs-network'
import { ErrorBoundary } from '@appsignal/react'

import ErrorDisplay from './components/ErrorDisplay'
import Routes from './components/Routes'

import './App.css'
import Layout from './components/Layout'
import { ParticipantProvider } from './components/ParticipantContext'

const appsignal = new Appsignal({
  key: import.meta.env.VITE_APPSIGNAL_PUSH_API_KEY,
  revision: import.meta.env.VITE_GIT_SHORT_SHA
})

appsignal.use(appSignalBreadcrumbsNetwork())

const App = (): JSX.Element => (
  <HelmetProvider>
    <ApolloProvider>
      <ParticipantProvider>
        <BrowserRouter>
          <Layout>
            <ErrorBoundary
              instance={appsignal}
              fallback={(error: any) => <ErrorDisplay error={error} />}
            >
              <Routes />
            </ErrorBoundary>
          </Layout>
        </BrowserRouter>
      </ParticipantProvider>
    </ApolloProvider>
  </HelmetProvider>
)

export default App
